<template>
    <div class="
        w:320 bg:white r:8
        box-shadow:0|0|20|0|black/.1
    ">
        <div class="flex jc:space-between ai:center p:14|16">
            <div class="
                flex ai:center flex:1 gap:8
                {r:100;p:2|10;bg:white;b:1|solid|#EBEBEB;f:14}>button
                {bg:#78C8FB;border-color:transparent}>button.active
            ">
                <button :class="{ active: tab === 1 }" @click="tab = 1" type="button">Emoji</button>
                <button :class="{ active: tab === 2 }" @click="tab = 2" type="button" v-if="!attachment">GIF</button>
                <button :class="{ active: tab === 3 }" @click="tab = 3" type="button" v-if="!attachment">YT動效</button>
            </div>
            <button class="bg:url(image/icon_round_close.svg) w:33 h:32 b:0" @click="close" type="button"></button>
        </div>
        <div class="overflow-y:auto h:360 p:12" v-if="tab === 1">
            <div class="grid grid-cols:7 ai:start gap:8|12 w:284 mx:auto">
                <button class="b:0 f:32 lh:32px" @click="emit('select', 'emoji', item)" :key="item.id" :title="item.title" type="button" v-for="item in emojis">{{ item.code }}</button>
            </div>
        </div>
        <div v-else-if="tab === 2">
            <div class="p:8|16">
                <form action="." class="p:1 bg:linear-gradient(290.86deg,rgba(248,195,233,0.99)|0%,#C1DDFF|25.49%,#CAE3F3|78.2%,#EFE8AC|100.77%) r:100" @submit.prevent="searchGif">
                    <input
                        class="w:full r:100 p:8|16|8|40 background-color:#F6F9FF bg:no-repeat background-position:left|16|center background-image:url(image/icon_search.svg) background-size:16|16 f:12 outline:none!"
                        placeholder="搜尋GIF"
                        type="search"
                        v-model.trim="gifKeyword"
                    />
                </form>
            </div>
            <div class="px:16 b:1|solid|#EBEBEB border-width:1|0">
                <ul class="
                    m:0 p:0 flex gap:16 h:34
                    {inline-flex}>li
                    {py:8;b:0;px:0;m:0;inline-flex;ai:center}>li>button
                    {rel}>li>button.active
                    {content:'';h:2;w:full;bottom:0;left:0;rt:1;bg:#78C8FB;abs}>li>button.active::after
                ">
                    <li>
                        <button :class="{ active: tab2 === 1 }" @click="tab2 = 1" type="button">
                            <span class="bg:url(image/icon_time.svg) w:17 h:16 inline-block"></span>
                        </button>
                    </li>
                    <li>
                        <button class="f:12" :class="{ active: tab2 === 2 }" @click="tab2 = 2" type="button" v-if="gifResult">
                            搜尋結果
                        </button>
                    </li>
                </ul>
            </div>
            <div class="overflow-y:auto h:352 p:12|16">
                <div class="columns:2 gap:12 {inline-block;mb:12;cursor:pointer;r:8;w:full}_img">
                    <template :key="item.id" v-for="item in gifItems">
                        <img alt="" @click="emit('select', 'gif', item)" :src="`https://i.giphy.com/${item.id}.gif`" />
                    </template>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="p:8|16">
                <form action="." class="p:1 bg:linear-gradient(290.86deg,rgba(248,195,233,0.99)|0%,#C1DDFF|25.49%,#CAE3F3|78.2%,#EFE8AC|100.77%) r:100" @submit.prevent="searchYt">
                    <input
                        class="w:full r:100 p:8|16|8|40 background-color:#F6F9FF bg:no-repeat background-position:left|16|center background-image:url(image/icon_search.svg) background-size:16|16 f:12 outline:none!"
                        placeholder="搜尋YT動效"
                        type="search"
                        v-model.trim="ytKeyword"
                    />
                </form>
            </div>
            <div class="px:16 b:1|solid|#EBEBEB border-width:1|0">
                <ul class="
                    m:0 p:0 flex gap:8 h:34
                    {inline-flex}>li
                    {py:8;b:0;px:0;m:0;inline-flex;ai:center;gap:4;f:12;lh:16px;h:32}>li>button
                    {rel}>li>button.active
                    {content:'';h:2;w:full;bottom:0;left:0;rt:1;bg:#78C8FB;abs}>li>button.active::after
                ">
                    <li>
                        <button :class="{ active: tab3 === 1 }" @click="tab3 = 1" type="button">
                            <span class="bg:url(image/icon_time.svg) w:17 h:16 inline-block"></span>
                        </button>
                    </li>
                    <li>
                        <button :class="{ active: tab3 === 2 }" @click="tab3 = 2" type="button">
                            <img alt="" class="h:16" src="asset/image/icon_yt03.svg" />
                        </button>
                    </li>
                    <li>
                        <button class="f:12" :class="{ active: tab3 === 3 }" @click="tab3 = 3" type="button" v-if="ytResult">
                            搜尋結果
                        </button>
                    </li>
                    <li class="ml:auto">
                        <button class="color:#78C8FB lh:34" @click="ytModal.show()" type="button">
                            <i class="f:14 fa-solid fa-plus"></i>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="overflow-y:auto h:352 p:12|16">
                <div class="columns:2 gap:12 {inline-block;mb:12;cursor:pointer;r:8;w:full}>div">
                    <template :key="item.id" v-for="item in ytItems">
                        <yt-player @click="emit('select', 'yt', item)" :content="item" :editable="tab3 === 2" @remove="removeYt(item)"></yt-player>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <comment-yt-modal ref="ytModal" @submit="tab3 = 2"></comment-yt-modal>
</template>

<script setup>
    const props = defineProps({
        attachment: { type: Boolean }
    });

    const ytModal = ref()

    const emojis = ref();
    const gifKeyword = ref();
    const gifRecent = ref();
    const gifResult = ref();
    const opened = ref(false);
    const tab = ref();
    const tab2 = ref();
    const tab3 = ref();
    const ytKeyword = ref();
    const ytList = ref();
    const ytRecent = ref();
    const ytResult = ref();

    const gifItems = computed(() => {
        switch (tab2.value) {
            case 1:
                return gifRecent.value;
            case 2:
                return gifResult.value;
        }
    });

    const close = () => {
        opened.value = false;
        tab.value = 1;
    };

    const emit = defineEmits(["select"]);

    const removeYt = (target) => {
        api("api/comment/yt/remove", { id: target.id }).done((res) => {
            if (res.success) {
                ytList.value = ytList.value.filter((item) => item !== target);
            }
        });
    };

    const searchGif = () => {
        if (gifKeyword.value) {
            api("api/comment/gif/search", { keyword: gifKeyword.value }).done((res) => {
                if (res.success) {
                    gifResult.value = res.data;
                    tab2.value = 2;
                }
            });
        }
    };

    const searchYt = () => {
        if (ytKeyword.value) {
            api("api/comment/yt/search", { keyword: ytKeyword.value }).done((res) => {
                if (res.success) {
                    ytResult.value = res.data;
                    tab3.value = 3;
                }
            });
        }
    };

    const toggle = () => {
        opened.value = !opened.value;

        if (!tab.value) {
            tab.value = 1;
        }
    };

    const ytItems = computed(() => {
        switch (tab3.value) {
            case 1:
                return ytRecent.value;
            case 2:
                return ytList.value;
            case 3:
                return ytResult.value;
        }
    });

    defineExpose({ close, opened, toggle });

    watch(gifKeyword, () => {
        if (!gifKeyword.value) {
            gifResult.value = null;
            tab2.value = 1;
        }
    });

    watch(ytKeyword, () => {
        if (!ytKeyword.value) {
            ytResult.value = null;
            tab3.value = 1;
        }
    });

    watch(() => props.attachment, () => {
        if (props.attachment && tab.value) {
            tab.value = 1;
        }
    });

    watch(tab, () => {
        switch (tab.value) {
            case 1:
                if (!emojis.value) {
                    api("api/comment/list-emoji").done((res) => {
                        if (res.success) {
                            emojis.value = res.data;
                        }
                    });
                }
                break;
            case 2:
                if (!tab2.value) {
                    tab2.value = 1;
                }
                break;
            case 3:
                if (!tab3.value) {
                    tab3.value = 1;
                }
                break;
        }
    });

    watch(tab2, () => {
        switch (tab2.value) {
            case 1:
                api("api/comment/gif/recent").done((res) => {
                    if (res.success) {
                        gifRecent.value = res.data;
                    }
                });
                break;
        }
    });

    watch(tab3, () => {
        switch (tab3.value) {
            case 1:
                api("api/comment/yt/recent").done((res) => {
                    if (res.success) {
                        ytRecent.value = res.data;
                    }
                });
                break;
            case 2:
                api("api/comment/yt/list").done((res) => {
                    if (res.success) {
                        ytList.value = res.data;
                    }
                });
                break;
        }
    });
</script>
